import React, { useState } from 'react';
import { Form, Grid, Image, Segment, Message, Modal } from 'semantic-ui-react';
import logo from './../../img/logo_image_crucia.jpg';
import auth from './auth';

export const Login = props => {
    const [usuario, setUsuario] = useState(0);
    const [pass, setPass] = useState(0);
    const [nuevoPass, setNuevoPass] = useState(0);
    const [incorrecto, setIncorrecto] = useState();
    const [passNuevo, setPassNuevo] = useState(0);
    const [passNuevoConfirm, setPassNuevoConfirm] = useState(0);

    
    async function onSubmit(e) {
        e.preventDefault();
        
        //const url = `http://192.168.87.41:8000/login/${usuario}/${pass}/`;
        const url = `http://webservices.crucianelli.com:8000//login/${usuario}/${pass}/`;
        
        console.log(url);

        //query con fetch api asincronica
        let response = await fetch(url, {
	        'mode': 'cors',
	        'headers': {
            	'Access-Control-Allow-Origin': '*',
        	}
        });
        
        let data = await response.json();
        
        console.log(data.length);

        if (data.length !== 0) {
            const {user, items} = data;

            console.log(user);
            console.table(items);
            
            auth.usuario = data;
            auth.nombre = data.user[0]['nombre'];
            auth.cod_concesionario = data.user[0]['cod_concesionario'];

            if (data.user[0]['primer_ingreso'] === 1){
                setNuevoPass(1);
            }else{
                auth.login(() => {
                    props.history.push('/');
                });
            }
            
        }else{
            setIncorrecto(1);
        }
        
    }

    async function handlePassChange(e){
        
        e.preventDefault();

        var cod_cli = auth.usuario.user[0]['cod_cli'];

        if (passNuevo === '' || passNuevo === 0 || passNuevo === undefined) return 

        if (passNuevo !== passNuevoConfirm){
            alert("La contraseña ingresada no coincide con su confirmación.")
        }else{

        //const url = "http://webservices.crucianelli.com:8000//actualizarPassword/"
        const url = "http://webservices.crucianelli.com:8000//actualizarPassword/"

        //Actualizo contraseña en BD. 
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                cod_cli: cod_cli,
                password_nuevo: passNuevo
            })
        });

        //Actualizo state para cerrar modal
        setNuevoPass(0);

        auth.login(() => {
            props.history.push('/');
        });
        } 
    }
    
    function handleChangeUsuario(e, { value }){
        setUsuario(value);
    }
    
    function handleChangePass(e, { value }){
        setPass(value);
    }

    function handlePassNuevo(e, { value }){
        setPassNuevo(value);
    }

    function handlePassNuevoConfirm(e, { value }){
        setPassNuevoConfirm(value);
    }

    return (
        <div >
            <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450 }}>
                <Image src={logo} centered/>
                <p></p>
                <p></p>
                <Form size='large' onSubmit={onSubmit}>
                    <Segment stacked>
                    <Form.Input fluid icon='user' iconPosition='left' placeholder='Usuario' name = 'usuario'  onChange={handleChangeUsuario}/>
                    <Form.Input
                        fluid
                        icon='lock'
                        iconPosition='left'
                        placeholder='Contraseña'
                        type='password'
                        name = 'pass'
                        onChange={handleChangePass}
                    />
                    <Form.Button type="submit" color='red' fluid size='large'>
                        Acceder
                    </Form.Button>
                    </Segment>
                </Form>
                {incorrecto ? <Message negative>
                    <Message.Header>Error al intentar ingresar</Message.Header>
                    <p>Usuario y/o contraseña invalidos.</p>
                </Message>: <div></div>}
                </Grid.Column>
                <Modal 
                    as={Form} 
                    onSubmit={e => handlePassChange(e)}
                    open={nuevoPass}
                    size="small">
                    <Grid textAlign='center' style={{ height: '40vh' }} verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        
                    <h3>Bienvenido, antes de continuar deberá cambiar la contraseña enviada por correo.</h3>
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            placeholder='Nueva contraseña'
                            type='password'
                            name = 'pass'
                            onChange={handlePassNuevo}
                        />
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            placeholder='Confirme contraseña'
                            type='password'
                            name = 'pass'
                            onChange={handlePassNuevoConfirm}
                        />
                        <Form.Button type="submit" color='red' fluid size='large'>
                        Cambiar contraseña
                        </Form.Button>
                    </Grid.Column>
                    </Grid>
                </Modal>
            </Grid>
        </div>
    );
}
